import React from "react";

const Input = ({ label, helper, error, className = "", ...props }) => {
  const { type, inputMode, enterKeyHint, pattern, ...restProps } = props;

  const isNumericField = type === "number";
  const resolvedType = isNumericField ? "text" : type;

  const resolvedInputMode =
    inputMode ||
    (isNumericField
      ? "decimal"
      : type === "email"
        ? "email"
        : type === "tel"
          ? "tel"
          : type === "search"
            ? "search"
            : undefined);

  const resolvedEnterKeyHint =
    enterKeyHint || (type === "search" ? "search" : "done");
  const resolvedPattern = pattern || (isNumericField ? "[0-9]*[.]?[0-9]*" : undefined);

  return (
    <label className="flex flex-col gap-2 text-sm text-slate-600">
      {label}
      <input
        className={[
          "h-11 rounded-lg border px-4 text-base text-slate-900 shadow-sm",
          "outline-none transition",
          error ? "border-rose-300 focus:border-rose-400" : "border-slate-200 focus:border-slate-400",
          className,
        ]
          .filter(Boolean)
          .join(" ")}
        type={resolvedType}
        inputMode={resolvedInputMode}
        enterKeyHint={resolvedEnterKeyHint}
        pattern={resolvedPattern}
        {...restProps}
      />
      {helper && !error && <span className="text-xs text-slate-500">{helper}</span>}
      {error && <span className="text-xs text-rose-600">{error}</span>}
    </label>
  );
};

export default Input;
